import { render } from "./DeleteActivityModal.vue?vue&type=template&id=f59a1a6e&scoped=true"
import script from "./DeleteActivityModal.vue?vue&type=script&lang=js"
export * from "./DeleteActivityModal.vue?vue&type=script&lang=js"

import "./DeleteActivityModal.vue?vue&type=style&index=0&id=f59a1a6e&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59a1a6e"]])

export default __exports__